/* eslint-disable func-names */
/*
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 *
 * For browsers that do not support Element.closest(), but carry support for
 * element.matches() (or a prefixed equivalent, meaning IE9+), a polyfill exists:
 */

if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (selector) {
        let element = this;

        do {
            if (Element.prototype.matches.call(element, selector)) return element;
            element = element.parentElement || element.parentNode;
        } while (element !== null && element.nodeType === 1);

        return null;
    };
}
